import { IRequestCommand } from "app/services/authentication/connection/iRequestCommand";
import { CommandRequestType } from "app/services/authentication/connection/commandRequestType";
import { ICommandParameters } from "app/services/authentication/connection/iCommandParameters";
import { ICommandResponse } from "app/services/authentication/connection/iCommandResponse";
import { ErrorDetails } from "app/services/authentication/connection/interfaces/apiInterfaces";

export class GetIconsServicesTypeCommand extends IRequestCommand<
  IGetIconsServicesTypeResponse,
  ErrorDetails,
  IGetIconsServicesTypeCommandParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.GET;
  override _commandUrl = 'carriers/{carrierId}/serviceTypes/availableIcons';
  public override setParameters(parameters: IGetIconsServicesTypeCommandParameters) {
    this._commandUrl = this._commandUrl.replace(
      '{carrierId}',
      parameters.carrierId
    );
  }
}

export interface IGetIconsServicesTypeCommandParameters extends ICommandParameters {
  carrierId?: string;
}

export interface IGetIconsServicesTypeResponse
  extends ICommandResponse {}
